<template>
    <div class="notice-process">
        <me-notice-bar
             v-if="Object.keys(data).length"
            color="rgba(69, 90, 100, 0.6)"
            background="#f7f7f7">答卷进度统计(仅限通知任务收集的答题数据)</me-notice-bar>
        <div class="table-wrap" v-if="Object.keys(data).length">
            <table class="table">
                <tr>
                    <td colspan="3" align="center" class="all">全部：{{data.total}}条</td>
                </tr>
                <tr>
                    <td>发送失败</td>
                    <td>{{data.sendFail}}条</td>
                    <td>{{data.sendFailRate}}</td>
                </tr>
                <tr>
                    <td>已发送未打开</td>
                    <td>{{data.notOpen}}条</td>
                    <td>{{data.notOpenRate}}</td>
                </tr>
                <tr>
                    <td>打开未提交</td>
                    <td>{{data.notAnswer}}条</td>
                    <td>{{data.notAnswerRate}}</td>
                </tr>
                <!-- <tr>
                    <td>填写未提交</td>
                    <td>{{data.notSubmit}}条</td>
                    <td>{{data.notSubmitRate}}</td>
                </tr> -->
                <tr>
                    <td>有效答卷</td>
                    <td>{{data.validCount}}条</td>
                    <td>{{data.validCountRate}}</td>
                </tr>
            </table>
        </div>
        <me-notice-bar v-if="list.length" color="rgba(69, 90, 100, 0.6)" background="#f7f7f7">发送记录</me-notice-bar>
        <me-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            >
            <ul class="list">
                <li
                    class="item"
                    v-for="(item, index) in list"
                    :key="index">
                    <div class="sendTime">{{index + 1}}、发送时间：{{item.sendTime}}</div>
                    <div>数量：{{item.totalCount}}</div>
                    <div>状态：<span :class="[item.currentStatusCode === 'completed' ? 'green' : 'red']">{{item.currentStatus}}</span></div>
                    <div>短信：{{item.smsContent}}</div>
                    <div>来源：{{item.batchSource}}</div>
                    <div class="send-btns">
                        <span @click="showRetry(item)" v-if="item.currentStatusCode === 'completed'">批量重发</span>
                        <span class="process" v-if="item.currentStatusCode !== 'fail'" @click="exportProcess(item)">导出答卷进度</span>
                    </div>
                </li>
            </ul>
        </me-list>
        <me-popup v-model="show" position="bottom">
            <bottomConfirm
                text="重新发送"
                @cancel="cancelPop"
                @confirm="confirmPop"
                @close="close">
                <div class="dialog-content">
                    <div class="btns">
                        <span
                            v-for="(item, index) of btns"
                            :key="index"
                            @click="active=item.value"
                            class="btn"
                            :class="{active: active === item.value}">{{item.name}}</span>
                    </div>
                </div>
            </bottomConfirm>
        </me-popup>
    </div>
</template>
<script>
import { addClass2, removeClass2 } from '@/util/status-util'
import bottomConfirm from '../compontents/bottom_confirm.vue'
import { Questionnaire } from '@/network'
import { mixin } from '@/mixins'
import { Toast } from '@guazi-fe/melon'
import browser from '@/util/browser'
import NativeApi from 'native-api'

export default {
    name: 'notice-process',
    data() {
        return {
            data: {},
            list: [],
            pageNum: 1,
            pageSize: 20,
            loading: false,
            finished: false,
            show: false,
            btns: [{
                name: '已发送未打开',
                value: 1,
            },{
                name: '打开未提交',
                value: 2,
            },{
                name: '有效答卷',
                value: 4,
            },{
                name: '发送失败',
                value: 5,
            }],
            active: 0,
            batchNo: 0,
        }
    },
    mixins: [mixin],
    components: { bottomConfirm },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
    },
    created() {
        this.statistic()
    },
    methods: {
        onLoad() {
            this.search()
        },
        search(flag) {
            const { tid, pageId, pageSize, pageNum } = this
            const data = {
                tid,
                pageId,
                pageNum,
                pageSize
            }
            Questionnaire.sendList(data).then((res) => {
                let { data: { data: { list, total } } } = res
                this.list = flag ? list : this.list.concat(list)
                this.loading = false
                if (this.list.length >= total) {
                    this.finished = true
                    return
                }
                this.pageNum++
            })
        },
        statistic() {
            const data = {
                tid: this.tid,
                pageId: this.pageId,
            }
            Questionnaire.statistic(data).then((res) => {
                let { data: { data } } = res
                this.data = data
            }).catch((err) => {
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        exportProcess(item) {
            const { guaguaApp } = browser
            const data = {
                tid: this.tid,
                batchNo: item.batchNo,
            }
            const downUrl = location.protocol + Questionnaire.exportProcess(data) + '&v=' + new Date().getTime()
            var date = new Date()
            if (guaguaApp) {
                 NativeApi.invoke('downloadFile', {
                    fileUrl: downUrl,
                    fileName: `答卷批次${item.batchNo}-的进度数据汇总-${date.getFullYear()}${date.getMonth()+1}${date.getDate()}${Math.round(Math.random(10000)*89999)}.xlsx`,
                })
                return
            }
            window.open(downUrl)
        },
        showRetry(item) {
            this.batchNo = item.batchNo
            this.show = true
        },
        cancelPop() {
            this.show = false
        },
        confirmPop() {
            const data = {
                tid: this.tid,
                batchNo: this.batchNo,
                operateType: this.active
            }
            addClass2('body', 'loading')
            Questionnaire.retry(data).then((res) => {
                Toast.success('重新发送成功！')
                this.show = false
                removeClass2('body', 'loading')
                this.pageNum = 1
                document.documentElement.scrollTop = 0
                document.body.scrollTop = 0
                this.search(true)
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        close() {
            this.show = false
        },
    }
}
</script>
<style scoped lang="scss">
    .table-wrap{
        background: #fff;
        padding: .42rem;
        line-height: .74rem;
    }
    .table{
        width: 100%;
        border-top: 1PX solid #DBDBDB;
        border-left: 1PX solid #DBDBDB;
        border-collapse: collapse;
        td{
            border-bottom: 1PX solid #DBDBDB;
            border-right: 1PX solid #DBDBDB;
            padding-left: .2rem;
            color: #5F6670;
            font-size: .32rem;
        }
        .all{
            line-height: 1.17rem;
            background: #F6F6F6;
            color: #333333;
            font-size: .37rem;
        }
    }
    .list{
        background: #fff;
        padding: .42rem;
        line-height: .72rem;
        font-size: 0.37333rem;
        color: #9298A8;
        .item{
            padding-left: .75rem;
            .sendTime{
                position: relative;
                left: -.6rem;
            }
            .green{
                color: #06B455;
            }
            .red{
                color:#F74D4D;
            }
        }
        .item:not(:last-child) {
            border-bottom: 1px solid #DBDBDB;
            padding-bottom: 0.42rem;
        }
        .item:not(:first-child) {
            padding-top: 0.42rem;
        }
        .send-btns{
            margin-top: .32rem;
            display: flex;
            justify-content: flex-end;
            >span{
                padding: .05rem .2rem;
                border: 1px solid #dbdbdb;
                border-radius: .15rem;
            }
            .process{
                margin-left: .32rem;
            }
        }
    }
    .dialog-content{
        padding: .3rem .3rem .5rem;
        .btns{
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            .btn{
                width: 4.16rem;
                line-height: 1.226rem;
                text-align: center;
                background: #F6F6F6;
                color: #333333;
                font-size: 0.3733rem;
                border-radius: 0.16rem;
                margin-bottom: .2rem;
                &.active{
                    background: #06B455;
                    color: #fff;
                }
            }
        }
    }
</style>
